import { useContext } from "react";
import { PictureSetsContext } from "../providers/PictureSetsProvider";
export function useAddToCartUseBuyNow() {
    var _a;
    const pictureSetsContext = useContext(PictureSetsContext);
    const currentPictureSet = pictureSetsContext === null || pictureSetsContext === void 0 ? void 0 : pictureSetsContext.currentPictureSet;
    return ((_a = currentPictureSet === null || currentPictureSet === void 0 ? void 0 : currentPictureSet.experiments) === null || _a === void 0 ? void 0 : _a.addToCartUseBuyNow) === true;
}
